import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from 'emotion-theming';
import { makeStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField'; // Import Components

import { Button, Link } from '@jelly/ui';
import { EmailSubscribeContext } from '../EmailSubscribeProvider';
import { Search } from '../svgs/Search';
import { SearchPanel } from '../Search/SearchPanel';
import { SiteConfigContext } from '../SiteConfigProvider';
import { SubHubHamburgerMenu } from '../HamburgerMenu/SubHubHamburgerMenu';
import { SubHubMenu } from './SubHubMenu';
import { trackNavEvent } from '../HeaderBanner';

var useStyles = function useStyles(_ref) {
  var isMenuPanelOpen = _ref.isMenuPanelOpen;
  return makeStyles(function (theme) {
    var _HubMenuContainer, _IconContainer, _LeftSideContainer, _SearchIconWrapper;

    return {
      AdvertiseWithUsButton: {
        height: '36px',
        marginRight: '1rem',
        padding: '0 1rem',
        width: 'auto'
      },
      ElementIcon: {
        margin: 'auto'
      },
      Form: _defineProperty({
        marginRight: '0',
        maxWidth: '70%'
      }, theme.breakpoints.up('md'), {
        marginRight: '1.5rem',
        maxWidth: '100%'
      }),
      Hamburger: {
        display: 'flex',
        flexDirection: 'column',
        height: '40%',
        justifyContent: 'space-between',
        margin: 'auto',
        position: 'relative',
        width: '35px'
      },
      HamburgerWrapper: _defineProperty({
        border: '0',
        cursor: 'pointer',
        display: 'inline-block',
        background: theme.palette.common.white,
        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.12)',
        height: '45px',
        position: 'relative',
        verticalAlign: 'top',
        minWidth: '65px',
        zIndex: '1000',
        width: '100%'
      }, theme.breakpoints.up('sm'), {
        height: '55px',
        width: '80px'
      }),
      HeaderBannerWrapper: {
        display: 'flex',
        height: '100%',
        margin: 'auto',
        maxWidth: theme.breakpoints.values.xl,
        position: 'relative',
        width: '100%'
      },
      HubMenuContainer: (_HubMenuContainer = {
        display: 'flex',
        justifyContent: 'space-between'
      }, _defineProperty(_HubMenuContainer, "justifyContent", 'space-evenly'), _defineProperty(_HubMenuContainer, "margin", 'auto'), _defineProperty(_HubMenuContainer, "maxWidth", theme.breakpoints.values.xl), _defineProperty(_HubMenuContainer, "textAlign", 'center'), _defineProperty(_HubMenuContainer, "width", '99%'), _defineProperty(_HubMenuContainer, theme.breakpoints.up('xl'), {
        width: '100%'
      }), _HubMenuContainer),
      IconContainer: (_IconContainer = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 'auto 0 auto auto',
        right: '0',
        zIndex: '4'
      }, _defineProperty(_IconContainer, theme.breakpoints.up('sm'), {
        zIndex: '1'
      }), _defineProperty(_IconContainer, theme.breakpoints.up('max'), {
        '& li:last-child': {
          marginRight: '0'
        }
      }), _IconContainer),
      JoinButton: {
        height: '36px',
        margin: '0 1rem',
        padding: '0 1rem',
        width: 'auto'
      },
      Layer: {
        background: theme.palette.secondary.main,
        display: 'block',
        height: '2px',
        position: 'relative',
        transformOrigin: '4px 0px',
        transition: "transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),\n\t\t\t\topacity 0.55s ease",
        '&:nth-of-type(1)': _defineProperty({
          transform: isMenuPanelOpen ? 'rotate(45deg) translate(0, -5px)' : 'rotate(0deg)'
        }, theme.breakpoints.up('sm'), {
          transform: isMenuPanelOpen ? 'rotate(45deg) translate(2px, -2px)' : 'rotate(0deg)'
        }),
        '&:nth-of-type(2)': {
          display: isMenuPanelOpen ? 'none' : 'block',
          transition: 'all 1s ease'
        },
        '&:nth-of-type(3)': {
          transform: isMenuPanelOpen ? 'rotate(-45deg) translate(1px, 1px)' : 'rotate(0deg)'
        }
      },
      LeftSideContainer: (_LeftSideContainer = {
        display: 'flex',
        paddingTop: '0.5rem'
      }, _defineProperty(_LeftSideContainer, theme.breakpoints.up('lg'), {
        paddingLeft: '0.5rem'
      }), _defineProperty(_LeftSideContainer, theme.breakpoints.up('xl'), {
        paddingLeft: '0'
      }), _LeftSideContainer),
      LogoContainer: _defineProperty({
        zIndex: '1001'
      }, theme.breakpoints.up('xl'), {
        zIndex: '1'
      }),
      NavigationBar: {
        background: theme.palette.tertiary.main,
        width: '100%'
      },
      Overlay: {
        background: theme.palette.primary.main,
        height: '100vh',
        position: 'absolute',
        top: '0',
        opacity: '0.85',
        transition: 'all 0.2s ease',
        visibility: isMenuPanelOpen ? 'visible' : 'hidden',
        width: '100%',

        /* This is set to 3 because the MBP meatball menu has a z-index of 2 and we want to overlap that when the hamburger menu is open */
        zIndex: 3
      },
      SearchIconWrapper: (_SearchIconWrapper = {
        cursor: 'pointer',
        height: '20px',
        margin: '2px 1rem 0 0',
        width: '20px'
      }, _defineProperty(_SearchIconWrapper, theme.breakpoints.up('xs'), {
        marginRight: '1.5rem'
      }), _defineProperty(_SearchIconWrapper, '&:hover', {
        '& path, line': {
          stroke: theme.palette.secondary.main
        }
      }), _SearchIconWrapper),
      StyledInputAdorment: {
        height: '1.25rem',
        width: '1.25rem'
      },
      StyledTextField: {
        '& fieldset': {
          borderRadius: '0',
          margin: 'auto',
          minHeight: '40px'
        }
      }
    };
  }, {
    name: 'subHubHeader'
  });
};
/**
 * This is the Sub Hub Header Banner App Component
 *
 * Open and Close States:
 * 	- Solo Search Panel
 * 	- Solo Account Panel
 * 	- Search Panel from Hamburger Menu
 * 	- Account Panel from Hamburger Menu
 * 	- Account Panel within Tablet
 */


export function SubHubHeader() {
  var _useContext = useContext(SiteConfigContext),
      HeaderLogo = _useContext.siteComponents.HeaderLogo,
      _useContext$siteConst = _useContext.siteConstants,
      subscribeButton = _useContext$siteConst.EMAIL_CAPTURE_SOURCES.subscribeButton,
      HUB_LINKS = _useContext$siteConst.HUB_LINKS,
      SHOULD_SHOW_ADVERTISE_WITH_US_BUTTON = _useContext$siteConst.SHOULD_SHOW_ADVERTISE_WITH_US_BUTTON;

  var _useContext2 = useContext(EmailSubscribeContext),
      emailSubscribeFormSubmitted = _useContext2.emailSubscribeFormSubmitted,
      setEmailSubscribeSource = _useContext2.setEmailSubscribeSource,
      setIsVisible = _useContext2.setIsVisible;

  var _useTheme = useTheme(),
      MATCH_MEDIA = _useTheme.MATCH_MEDIA,
      strokeColor = _useTheme.search.strokeColor;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHamburgerMenuOpen = _useState2[0],
      setIsHamburgerMenuOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSearchPanelOpen = _useState4[0],
      setIsSearchPanelOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAccountPanelOpen = _useState6[0],
      setIsAccountPanelOpen = _useState6[1];

  var _useState7 = useState('small business'),
      _useState8 = _slicedToArray(_useState7, 2),
      searchTerm = _useState8[0],
      setSearchTerm = _useState8[1];

  var isMenuPanelOpen = isAccountPanelOpen || isSearchPanelOpen || isHamburgerMenuOpen;
  useEffect(function () {
    if (isMenuPanelOpen) {
      window.document.body.style.overflow = 'hidden';
      window.document.body.style.position = 'fixed';
    } else {
      window.document.body.style.overflow = 'visible';
      window.document.body.style.position = '';
    }
  }, [isMenuPanelOpen]);

  var handleEscPanel = function handleEscPanel(event) {
    if (event.keyCode === 27) {
      return isSearchPanelOpen ? setIsSearchPanelOpen(false) : isAccountPanelOpen ? setIsAccountPanelOpen(false) : setIsHamburgerMenuOpen(false);
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', handleEscPanel);
    return function () {
      document.removeEventListener('keydown', handleEscPanel);
    };
  });

  var handleMenuStatus = function handleMenuStatus(event, _ref2) {
    var _ref2$menuType = _ref2.menuType,
        menuType = _ref2$menuType === void 0 ? 'hamburger' : _ref2$menuType;
    event.preventDefault();
    var isMobile = !window.matchMedia(MATCH_MEDIA.S).matches;

    switch (menuType) {
      case 'account panel':
        isMobile && setIsAccountPanelOpen(!isAccountPanelOpen);
        break;

      case 'search panel':
        setIsSearchPanelOpen(!isSearchPanelOpen);
        break;

      case 'hamburger':
      default:
        if (isAccountPanelOpen) {
          setIsAccountPanelOpen(!isAccountPanelOpen);
          isHamburgerMenuOpen && setIsHamburgerMenuOpen(false);
        } else if (isSearchPanelOpen) {
          setIsSearchPanelOpen(!isSearchPanelOpen);
          isHamburgerMenuOpen && setIsHamburgerMenuOpen(false);
        } else {
          setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
        }

    }
  };

  var handleSubscribeClick = function handleSubscribeClick(e, slug) {
    e.preventDefault();
    trackNavEvent({
      destination: slug,
      type: 'Subscribe'
    });
  };

  var handleAdvertiseWithUsClick = function handleAdvertiseWithUsClick(slug) {
    trackNavEvent({
      destination: slug,
      type: 'Header AdvertiseWithUs link'
    });
  };

  var handleDesktopSearchSubmit = function handleDesktopSearchSubmit(event) {
    event.preventDefault();
    window.location.href = "/search/?q=".concat(searchTerm);
  };

  var classes = useStyles({
    isMenuPanelOpen: isMenuPanelOpen,
    isHamburgerMenuOpen: isHamburgerMenuOpen,
    isSearchPanelOpen: isSearchPanelOpen
  })();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.Overlay,
    onClick: function onClick(e) {
      return handleMenuStatus(e, {
        menuType: 'hamburger'
      });
    }
  }), /*#__PURE__*/React.createElement(SearchPanel, {
    handleClosePanel: function handleClosePanel(e) {
      return handleMenuStatus(e, {
        menuType: 'search panel'
      });
    },
    isSearchVisible: isSearchPanelOpen,
    showBackToMenu: isHamburgerMenuOpen
  }), /*#__PURE__*/React.createElement("nav", {
    className: classes.HeaderBannerWrapper,
    role: "navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.LeftSideContainer
  }, /*#__PURE__*/React.createElement(Hidden, {
    lgUp: true,
    initialWidth: "xs"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isHamburgerMenuOpen,
    "aria-label": "hamburger menu",
    className: classes.HamburgerWrapper,
    onClick: function onClick(e) {
      return handleMenuStatus(e, {
        menuType: 'hamburger'
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.Hamburger
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.Layer
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.Layer
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.Layer
  }))), /*#__PURE__*/React.createElement(SubHubHamburgerMenu, {
    handleMenuStatus: handleMenuStatus,
    handleSearchClick: function handleSearchClick(e) {
      return handleMenuStatus(e, {
        menuType: 'search panel'
      });
    },
    isHamburgerMenuOpen: isHamburgerMenuOpen
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.LogoContainer
  }, /*#__PURE__*/React.createElement(HeaderLogo, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.IconContainer
  }, !emailSubscribeFormSubmitted && /*#__PURE__*/React.createElement(Hidden, {
    lgDown: true,
    initialWidth: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.JoinButton,
    "aria-label": "Subscribe",
    onClick: function onClick(e) {
      handleSubscribeClick(e, window.location.href);
      setIsHamburgerMenuOpen(false);
      setIsVisible(true);
      setEmailSubscribeSource(subscribeButton);
    }
  }, "Subscribe")), /*#__PURE__*/React.createElement(React.Fragment, null, SHOULD_SHOW_ADVERTISE_WITH_US_BUTTON && /*#__PURE__*/React.createElement(Hidden, {
    lgDown: true,
    initialWidth: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Advertise With Us",
    as: Link,
    className: classes.AdvertiseWithUsButton,
    href: "/connect",
    onClick: function onClick() {
      return handleAdvertiseWithUsClick(window.location.href);
    },
    variant: "secondary"
  }, "Advertise With Us")), /*#__PURE__*/React.createElement(Hidden, {
    only: ['xs']
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.Form,
    noValidate: true,
    onSubmit: handleDesktopSearchSubmit
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "search",
    hidden: true
  }, "Search:"), /*#__PURE__*/React.createElement(TextField, {
    className: classes.StyledTextField,
    id: "search",
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        className: classes.StyledInputAdorment,
        position: "start"
      }, /*#__PURE__*/React.createElement(Search, {
        strokeColor: strokeColor
      }))
    },
    "aria-label": "search",
    placeholder: "Search",
    onInput: function onInput(e) {
      return setSearchTerm(e.target.value);
    },
    variant: "outlined"
  }))), /*#__PURE__*/React.createElement(Hidden, {
    smUp: true,
    initialWidth: "xs"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.SearchIconWrapper,
    onClick: function onClick(e) {
      return handleMenuStatus(e, {
        menuType: 'search panel'
      });
    }
  }, /*#__PURE__*/React.createElement(Search, {
    strokeColor: strokeColor
  })))))), /*#__PURE__*/React.createElement(Hidden, {
    mdDown: true,
    initialWidth: "xs"
  }, /*#__PURE__*/React.createElement("nav", {
    className: classes.NavigationBar,
    role: "menubar"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.HubMenuContainer
  }, HUB_LINKS.map(function (link, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "hub-element-".concat(i)
    }, /*#__PURE__*/React.createElement(SubHubMenu, {
      featuredTopics: link.featuredTopics,
      slug: link.slug,
      subHubs: link.subHubs,
      title: link.title
    }));
  })))));
}
export default SubHubHeader;